import isEmpty from 'lodash/isEmpty';
import { bool, func } from 'prop-types';
import React from 'react';

import DiscardableForm from '../../generic/DiscardableForm';
import FileUploader from '../../generic/FileUploader';
import api from '../../REST/api';
import withApiRequest from '../../REST/with-api-request';
import { flash } from '../../utils/flash';

const endpoint = api.uploadContacts;

const fileMetaFields = [{ id: 'name', name: 'Name', placeholder: 'File name' }];

class UploadContacts extends React.Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(event) {
    event.preventDefault();
    event.stopPropagation();

    const { onRequest, loading } = this.props;

    // This handles multiple save clicks
    const getUploaderState = endpoint.uploader.getState();
    if (getUploaderState.error) return;

    if (loading) return; // only make one request at a time

    const selectedFiles = endpoint.uploader.getFiles();
    if (isEmpty(selectedFiles)) return;

    onRequest()
      .then(response => {
        // Returns the server success msg
        flash(response[0].response.body.message);
      })
      .catch(console.error); // eslint-disable-line no-console
  }

  render() {
    return (
      <DiscardableForm onSubmit={this.handleSubmit}>
        <FileUploader
          hideUploadButton
          id="contact-file"
          manager={endpoint.uploader}
          metaFields={fileMetaFields}
          name="file"
          note="Select CSV for upload"
        />
      </DiscardableForm>
    );
  }
}

UploadContacts.propTypes = {
  onRequest: func.isRequired,
  loading: bool.isRequired,
};

export default withApiRequest({
  query: endpoint,
})(UploadContacts);
